var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSapphire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10156 0.775391H17.9016V17.5754H1.10156V0.775391Z",
    fill: "#4382FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9016 17.5732L9.50156 15.291L1.10156 17.5732",
    fill: "#4382FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9016 0.775391H1.10156L9.50156 3.05755L17.9016 0.775391ZM15.6194 9.17539L17.9016 17.5754V0.775391L15.6194 9.17539Z",
    fill: "#BBE5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50156 3.05755L1.10156 0.775391L3.38372 9.17539L9.50156 3.05755ZM3.38372 9.17539L1.10156 17.5754L9.50156 15.2932L3.38372 9.17539Z",
    fill: "#2F1FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5178 1.17383L9.11784 3.45599L3 9.57383L9.11784 15.6917L17.5178 17.9738L15.2357 9.57383L17.5178 1.17383Z",
    fill: "#94EBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.05664L13.7069 11.0992L15.6178 9.17448L9.5 3.05664Z",
    fill: "#2F1FC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapphire);
export default __webpack_public_path__ + "static/media/sapphire.c8e509fd741eea9635758dbf8e5711d6.svg";
export { ForwardRef as ReactComponent };